




































import VueOptions from '@utils/VueOptions'
import WizardNavbar from '@ui/AudienceCreativeWizard/WizardNavbar'
import WizardNavigation from '@ui/AudienceCreativeWizard/WizardNavigation'
import SetupForm from '@ui/SpaceWizards/OmnichannelSpaceWizard/Forms/SetupForm'
import Modal from '@components/Modal'

settings =
  name: 'OmnichannelSpaceEditStep'

  resources:
    space:
      resourceName: 'space'
      slug: 'suppliers/:wizard.supplierId/spaces/:spaceId/edit'
      params:
        creative_id: ':audienceCreativeId' #This cannot be called audience_creative_id because it crahses the space creation
    availabilities:
      resourceName: 'audience_availability'
      slug: 'suppliers/:wizard.supplierId/audience_availabilities'
      fetch: false
      params:
        quick_list: true

  vue:
    props: ['wizard', 'step']

    components: {
      WizardNavbar,
      WizardNavigation,
      SetupForm,
      Modal,
    }

    data: ->
      confirmModal:
        show: false

    computed:
      spaceId: ->
        @$route.query.spaceId

      audienceCreativeId: ->
        @wizard.audienceCreativeData.id

      form: ->
        data: @prime?.space
        errors: @formErrors.space || {}

      actionsForSetupForm: ->
        saveField: @saveField
        fetchSpace: @fetchSpace

      spaceAvailabilityIds: ->
        @form.data?.availability_ids || []

      hasVenues: ->
        @isNational || @spaceAvailabilityIds.length > 0

      isNational: ->
        !!@form.data?.omnichannel_national

    methods:
      hiNavigate: ->
        @wizard.navToStepName @step.navigation.next.to

      saveField: (fieldName) ->
        @saveItemField 'prime.space', fieldName, { skipFlash: true }

      onSave: ->
        @fetchSpace()

      fetchSpace: -> 
        @fetch 'space'

    watch:
      'wizard.audienceCreativeData': ->
        @fetch 'space'
      requestIsPending: (value) ->
        @wizard.hideWaitingModal() unless value

export default VueOptions.vue settings
